import { StatusInterface } from "../../models/TicketModule/Status";
import client from "../client";

class StatusService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/Statuses`;

      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<StatusInterface[]>(url);

      const sortedData = data.sort((a, b) => a.order - b.order);

      return sortedData;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/Statuses/getbyid/${id}`;

      const { data } = await client.get<StatusInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(status: StatusInterface) {
    try {
      let url = `/api/Statuses`;

      const { data } = await client.post<StatusInterface>(url, status);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, status: StatusInterface) {
    try {
      let url = `/api/Statuses/update/${id}`;

      const { data } = await client.post<StatusInterface>(url, status);

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/Statuses/remove/${id}`;
      await client.post<StatusInterface>(url, { url: "" });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default new StatusService();
